<template>
  <div>
    <template-one :data="one" fontBg="01"></template-one>
    <template-two :data="two" fontBg="02"></template-two>
    <template-three :data="three" fontBg="03"></template-three>
    <template-two :data="four" fontBg="04" bgColor="#FFFFFF"></template-two>
  </div>
</template>

<script>
import templateOne from "./templateOne";
import templateTwo from "./templateTwo";
import templateThree from "./templateThree";
export default {
  components: {
    templateOne,
    templateTwo,
    templateThree,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      one: {},
      two: {},
      three: {},
      four: {},
    };
  },
  watch: {
    data() {
      this.dataConvert();
    },
  },
  methods: {
    dataConvert() {
      let data = this.data;
      if (data.length < 1) {
        return;
      }
      this.getDataOne(data[0]);
      this.getDataTwo(data[1]);
      this.getDataThree(data[2]);
      this.getDataFour(data[3]);
    },
    getDataFour(obj) {
      if (obj) {
        let four = {
          title: obj.title,
          subTitle: obj.subTitle,
          url: "",
        };
        let tuWen = obj.tuWen;
        if (tuWen) {
          four.url = tuWen.image.url;
        }
        this.four = four;
        console.log("four:", four);
      }
    },
    getDataThree(obj) {
      if (obj) {
        let three = {
          title: obj.title,
          subTitle: obj.subTitle,
          bg: "",
          url: "",
          desc: "",
        };
        let tuWen = obj.tuWen;
        if (tuWen) {
          three.bg = tuWen.textBgImage.url;
          three.url = tuWen.image.url;
          three.desc = tuWen.description;
        }
        this.three = three;
      }
    },
    getDataTwo(obj) {
      if (obj) {
        let two = {
          title: obj.title,
          subTitle: obj.subTitle,
          bg: "",
          url: "",
          desc: "",
        };
        let tuWen = obj.tuWen;
        if (tuWen) {
          two.url = tuWen.image.url;
          two.bg = tuWen.textBgImage.url;
          two.desc = tuWen.description;
        }
        this.two = two;
      }
    },
    getDataOne(obj) {
      if (obj) {
        let one = {
          title: obj.title,
          subTitle: obj.subTitle,
          url: "",
          desc: "",
        };
        let tuWen = obj.tuWen;
        if (tuWen) {
          one.url = tuWen.image.url;
          one.desc = tuWen.description;
        }
        this.one = one;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
